import DateTool from '@/util/DateTool';
import { EngagementRewardVersion } from './EngagementRewardVersion';

export enum EngagementRewardType { ACCOUNT_OPENING_BONUS }

export enum DistributionCadence { END_OF_CYCLE }

export enum EngagementRewardSegmentation { PRODUCT }

export enum QualificationPeriodType { CYCLES }

export enum EngagementDurationType { ACTIVE_ALWAYS, ACTIVE_DURING_INTERVAL }

export const EngagementRewardTypeNames: Map<string, string> = new Map([
  ['ACCOUNT_OPENING_BONUS', 'Account Opening Bonus'],
]);

export const DistributionCadenceNames: Map<string, string> = new Map([
  ['END_OF_CYCLE', 'End of Cycle'],
]);

export const SegmentationNames: Map<string, string> = new Map([
  ['PRODUCT', 'By Product'],
]);

export const PeriodTypeNames: Map<string, string> = new Map([
  ['CYCLES', 'Cycles'],
]);

export const EngagementDurationTypeNames: Map<string, string> = new Map([
  ['ACTIVE_ALWAYS', 'Always Active'], ['ACTIVE_DURING_INTERVAL', 'Active During Interval'],
]);

export class EngagementReward {
  id: number | null = null;

  versions: EngagementRewardVersion[] = [];

  // ESLint does not recognize typescript overloaded constructors, so we have to turn these rules off.
  /* eslint no-useless-constructor: "off", no-dupe-class-members: "off" */
  constructor(fiId: string)

  constructor(fiId: string, id: number | null)

  constructor(fiId: string, id?: number | null) {
    if (id != null) {
      this.id = id;
    } else {
      this.versions.push(EngagementReward.createNewRewardVersion(fiId));
    }
  }

  public static createNewRewardVersion(fiId: string, id: number | null = null) {
    return {
      id,
      fiId,
      designStartDate: DateTool.todayBackendDate(),
      name: '',
      rewardType: EngagementRewardType[0],
      rewardAmount: 0,
      distributionCadence: DistributionCadence[0],
      startDate: null,
      endDate: null,
      segmentation: EngagementRewardSegmentation[0],
      qualificationTimes: 0,
      qualificationPeriods: 0,
      qualificationPeriodType: QualificationPeriodType[0],
      products: [],
      durationType: EngagementDurationType[0],
      activatedAtLeastOnce: false,
    };
  }

  // Get the version to display, either the current one, or the nearest
  // future version if there is no current.
  public getDisplayVersion(): EngagementRewardVersion | null {
    const todayTime: number = DateTool.getAustinDate().getTime();
    let bestMatch: EngagementRewardVersion | null = null;
    let bestMatchTime: number | null = null;

    this.versions.forEach((version: EngagementRewardVersion) => {
      if (bestMatch === null) {
        bestMatch = version;
        bestMatchTime = DateTool.parseDate(version.designStartDate).getTime();
      } else {
        const versionTime: number = DateTool.parseDate(version.designStartDate).getTime();
        if ((bestMatchTime! > todayTime && versionTime < bestMatchTime!)
          || (bestMatchTime! < todayTime && versionTime <= todayTime && versionTime > bestMatchTime!)) {
          bestMatch = version;
          bestMatchTime = versionTime;
        }
      }
    });

    return bestMatch;
  }

  public getCurrentVersion(): EngagementRewardVersion | null {
    const todayTime: number = DateTool.getAustinDate().getTime();
    let bestMatch: EngagementRewardVersion | null = null;
    let bestMatchTime: number | null = null;

    this.versions.forEach((version: EngagementRewardVersion) => {
      const versionTime: number = DateTool.parseDate(version.designStartDate).getTime();
      if (versionTime <= todayTime && (bestMatchTime === null || versionTime > bestMatchTime)) {
        bestMatch = version;
        bestMatchTime = versionTime;
      }
    });

    return bestMatch;
  }

  public findVersion(designStartDate: string): EngagementRewardVersion | null {
    let foundVersion: EngagementRewardVersion | null = null;
    for (let i = 0; i < this.versions.length; i++) {
      if (this.versions[i].designStartDate === designStartDate) {
        foundVersion = this.versions[i];
        break;
      }
    }

    return foundVersion;
  }

  public getNextVersion(version: EngagementRewardVersion): EngagementRewardVersion | null {
    let nextVersion: EngagementRewardVersion | null = null;
    for (let i = 0; i < this.versions.length - 1; i++) {
      if (this.versions[i] === version && i + 1 < this.versions.length - 1) {
        nextVersion = this.versions[this.versions.length - 1];
        break;
      }
    }
    return nextVersion;
  }
}


export default EngagementReward;
